import { Component, Input } from "@angular/core";
import { IVideo } from "../../../domain/models/video/video.model";
import { ILiveStream } from "../../../domain/models/live-stream/live-stream.model";
import { ELiveStreamStatus } from "../../../domain/enums/live-stream-status.enum";
import { CONTENT_FALLBACK_IMAGE, contentDuration, contentPosterUrl, isLiveNow } from "../../../domain/helpers/content.helper";

/**
 * The cover of a video or a live stream: poster, the badge in its corner and the student's watch
 * progress. Both applications draw it — the student in their video and live-stream lists, the coach
 * in the content library they assign from — so the badge rules live here rather than in each list.
 *
 * The corner badge says what is knowable: a duration for a video or a finished stream's recording,
 * the airing date for one still to come, and "canlı" while it is on.
 */
@Component({
  selector: 'app-content-poster',
  templateUrl: "./content-poster.component.html",
  styleUrl: "./content-poster.component.scss",
})
export class ContentPosterComponent {
  @Input() video?: IVideo | null;
  @Input() liveStream?: ILiveStream | null;

  @Input() posterHeight = 'auto';
  @Input() posterWidth = '100%';
  /** Off where the viewer is not the student, e.g. the coach's library. */
  @Input() showProgress = true;
  @Input() fallbackImage = CONTENT_FALLBACK_IMAGE;

  streamStatus = ELiveStreamStatus;

  title(): string {
    return this.video?.title ?? this.liveStream?.title ?? '';
  }

  posterUrl(): string {
    return contentPosterUrl({video: this.video, liveStream: this.liveStream}, this.fallbackImage);
  }

  duration(): number | null {
    return contentDuration({video: this.video, liveStream: this.liveStream});
  }

  isLive(): boolean {
    return isLiveNow(this.liveStream);
  }

  /** Watched-so-far bar; only a video the student has opened before carries one. */
  watchedPercent(): number | null {
    const watchedSeconds = this.video?.userVideoHistory?.timeInSec;
    if (!this.showProgress || !watchedSeconds || !this.video?.duration) {
      return null;
    }

    return (watchedSeconds * 1000) * 100 / this.video.duration;
  }
}
